import controller from './footer.controller';

export default {
  controller,
  template: require('./footer.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/components/footer/footer.component.ts